import * as React from "react";
import { Button, Link } from "react-ui";

import { ICandyApiDraftClient } from "../../../../../../Common/CandyApiClient/ICandyApiClient";
import { PRINT_EMBEDDEDLOG_FROM_MODAL_CLICK } from "../../../metricsAction";
import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { Icon } from "../../../Icons/Icon";

export interface PrintErrorLogProps {
    errorLogName: string;
    candyApiDraftClient: ICandyApiDraftClient;
    propsName: string;
}

export function PrintErrorLogButton(props: PrintErrorLogProps): JSX.Element {
    const track = useMetrics();
    const url = props.candyApiDraftClient.getHrefToErrorLogPdf(props.errorLogName, props.propsName);

    const handleOnClick = () => {
        track(PRINT_EMBEDDEDLOG_FROM_MODAL_CLICK);
    };

    return (
        <Link href={url} target="_blank">
            <Button
                icon={<Icon name="TechPrinterIcon" />}
                use={"primary"}
                data-tid="PrintErrorLog"
                onClick={handleOnClick}>
                Напечатать
            </Button>
        </Link>
    );
}
